import { ColorSAP } from "../../ontego-ui";
import { styled } from '@mui/material';

const Styled = {};

Styled.ButtonContainer = styled("div")(({ buttontheme }) => ({
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    "&::after": {
        content: "''",
        borderWidth: '0%',
        display: 'block',
        transition: '0.3s all ease-in-out'
    },
    "&:hover::after": {
        borderWidth: '100%',
    },

    color: buttontheme == "dark" ? ColorSAP.neutral[0] : buttontheme == "light" ? ColorSAP.neutral[100] : `${ColorSAP.primary[70]} !important`,
    borderBottom: `1.5px solid transparent`,
    "&:hover": {
        borderBottom: `1.5px solid ${buttontheme == "dark" ? ColorSAP.neutral[0] : buttontheme == "light" ? ColorSAP.neutral[100] : ColorSAP.primary[70]}`
    }
}));

Styled.ArrowContainer = styled("div")(({ size, iconTheme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: iconTheme === "dark" ? ColorSAP.neutral[15] : iconTheme === "light" ? ColorSAP.neutral[80] : ColorSAP.primary[70],

    "& svg": {
        width: size == "small" ? 16 : size == "medium" ? 22 : 38,
        height: size == "small" ? 16 : size == "medium" ? 22 : 38
    }
}));

export default Styled;